import request from '@/utils/request'

export function login(userName, password, code, uuid) {
  return request({
    url: '/auth/login',
    method: 'post',
    data: {
      userName: userName,
      password,
      code,
      uuid
    }
  })
}

export function getInfo() {
  return request({
    url: '/auth/info',
    method: 'get'
  })
}

export function getCodeImg() {
  return request({
    url: '/auth/code',
    method: 'get'
  })
}

export function logout() {
  return request({
    url: '/auth/logout',
    method: 'post'
  })
}
